<template>
  <div>Design&nbsp;: <a href="https://scantin.com" target="_blank" rel="noopener">scantin.com</a></div>
  <div>Programmation&nbsp;: <a href="https://websimple.com" target="_blank" rel="noopener">Websimple</a></div>
  <div>Rédaction&nbsp;: <a href="https://www.communicationantilope.com/" target="_blank" rel="noopener" class="inline-block">Communication Antilope</a></div>
</template>
